import React from 'react';
import { I18n } from 'react-redux-i18n';
import { ArrowLeft } from '@untitledui/icons';

import { I18N_BASE } from '../../constants';
import { EntityScope } from '../../models';
import CmButton from '../../components/primitives/CmButton';
import styles from './queue.module.css';

export interface QueueHistoryHeaderProps {
  scope: EntityScope;
  onBack: () => void;
  testId?: string;
}

export function QueueHistoryHeader({
  scope,
  onBack,
  testId,
}: QueueHistoryHeaderProps): React.ReactElement {
  // Reuse the queue card's subjectId labels ("Fundraiser #9823" etc.) so the
  // header reads consistently with how the entity appears elsewhere.
  const entityLabel = I18n.t(`${I18N_BASE}.queue.card.subjectId.${scope.kind}`, {
    id: scope.id,
  });

  return (
    <div className={styles.historyHeader} data-testid={testId} data-scope={scope.kind}>
      <CmButton variant="ghost" onClick={onBack} testId="history-back">
        <span className={styles.historyBackInner}>
          <ArrowLeft width={14} height={14} />
          {I18n.t(`${I18N_BASE}.queue.history.back`)}
        </span>
      </CmButton>
      <span className={styles.historyTitle}>
        {I18n.t(`${I18N_BASE}.queue.history.title`, { entity: entityLabel })}
      </span>
    </div>
  );
}

export default QueueHistoryHeader;
